import useClickOutside from '../../hooks/useClickOutsideHandler';
import Icon from '../../common/components/Icon';
import React, { useRef, useState } from 'react';
import { useTranslations } from '../../localization/useTranslations';

type DropdownItem = {
  label: string;
  sortBy: 'id' | 'price_amount' | 'created_at';
  sortOrder: 'asc' | 'desc';
};

export interface DropdownProps {
  items: DropdownItem[];
  onChange?: (item: DropdownItem) => void;
  selectedItem?: DropdownItem;
}

const Dropdown: React.FC<DropdownProps> = ({ items, onChange, selectedItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(selectedItem?.label || items[0].label);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const translations = useTranslations();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (item: {
    label: string;
    sortBy: 'id' | 'price_amount' | 'created_at';
    sortOrder: 'asc' | 'desc';
  }) => {
    setSelectedLabel(item.label);
    setIsOpen(false);
    onChange?.(item);
  };

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button className={`dropdown__toggle link-14 ${isOpen ? 'isOpen' : ''}`} onClick={toggleDropdown}>
        {translations?.ecommerce?.sortBy || 'Sort by'}: {selectedLabel}
        <Icon name="ecom-chevron-down" size="small" />
      </button>
      <ul className={`dropdown__menu ${isOpen ? 'isVisible' : ''}`}>
        {items.map((item, index) => (
          <li key={index} className="dropdown__item">
            <button className="dropdown__link link-16" onClick={() => handleSelect(item)}>
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
